import { ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator, Validators } from '@angular/forms';
import { CommodityType } from '@app/shared/enums/commodity-type';
import { UtilityDetails } from '@app/shared/models/customer-details';
import { UtilityRateCode } from '@app/shared/models/utility-rate-code';
import { UtilityInformationService } from '@app/shared/services/utility-information.service';
import { Subject, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '@app/state/app.state';

@Component({
  selector: 'app-load-profile-input',
  templateUrl: './load-profile-input.component.html',
  styleUrls: ['./load-profile-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LoadProfileInputComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => LoadProfileInputComponent),
      multi: true,
    },
  ],
})
export class LoadProfileInputComponent implements OnInit, OnChanges, ControlValueAccessor, Validator, OnDestroy {

  public frmUtilityRateCode: FormGroup;
  private updated = new Subject<string>();
  register$: Subscription;
  public onTouched: () => void = () => {};
  @Input() state: string;
  @Input() commodity: CommodityType;
  @Input() utilityDetails: UtilityDetails;
  @Input() quoteRequestId: number;
  @Input() utilityRateCode: string;
  @Input() shouldBeValidated: boolean;
  commodityType = CommodityType;
  utilityRateCodes: UtilityRateCode[];

  constructor(
    private utilityInformationService: UtilityInformationService,
    private store: Store<AppState>) 
  {
  }

  ngOnInit(): void {
    this.frmUtilityRateCode = new FormGroup({
      utilityRateCode: new FormControl({value: null, disabled: true})
    });
    this.load();

    this.frmUtilityRateCode.get('utilityRateCode').valueChanges.subscribe(val => {
      if (this.shouldBeValidated) {
        this.frmUtilityRateCode.controls['utilityRateCode'].setValidators([Validators.required]);
      } else {
        this.frmUtilityRateCode.controls['utilityRateCode'].clearValidators();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.state || changes.utilityDetails) {
        this.load();
    }
  }

  ngOnDestroy(): void {
    this.register$?.unsubscribe();
  }

  public loadProfileHasNoValue(): boolean {
    return false
  }

  public load() {
    if (!this.frmUtilityRateCode) {
      return;
    }
    if(this.state && this.utilityDetails && this.utilityDetails.utilityShort && this.utilityDetails.iso)
    {
      this.frmUtilityRateCode.get('utilityRateCode').enable();
      this.utilityInformationService.getUtilityRateCodesByCriteria(this.state, this.commodity, this.utilityDetails).subscribe(x => {
        this.utilityRateCodes = x;
        this.frmUtilityRateCode.get('utilityRateCode').setValue(this.utilityRateCodes.find(x => x.rateCode === this.utilityRateCode));
        this.frmUtilityRateCode.get('utilityRateCode').updateValueAndValidity();
      })
    } else {
      this.frmUtilityRateCode.get('utilityRateCode').setValue(null);
      this.frmUtilityRateCode.get('utilityRateCode').markAsPristine();
      this.frmUtilityRateCode.get('utilityRateCode').markAsUntouched();
    }
  }

  writeValue(val: any): void {
    if (val) {
      this.frmUtilityRateCode.patchValue(val, { emitEvent: false });
    }
    this.updated.next('form');
  }

  registerOnChange(fn: any): void {
    this.register$ = this.frmUtilityRateCode.valueChanges.subscribe((x) => fn(this.frmUtilityRateCode.getRawValue()));
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  validate(control: AbstractControl): ValidationErrors {
    if(control.errors && this.shouldBeValidated) {
      this.frmUtilityRateCode.get('utilityRateCode').markAsTouched();
      this.frmUtilityRateCode.get('utilityRateCode').markAsDirty();
    }
    return this.frmUtilityRateCode.valid ? null : { valid: false, message: 'Please select a Load Profile' };
  }

  registerOnValidatorChange?(fn: () => void): void {}

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {

    } else {
      this.frmUtilityRateCode.get('utilityRateCode').enable();
    }
  }

  clearUtilityRateCodeControl() {
    this.frmUtilityRateCode.get('utilityRateCode').setValue(null);
  }

}
